const SHADOW_HOST_ID = 'l5-cookie-consent';

let shadowRoot: ShadowRoot | undefined;

/**
 * The shadow root that our UI on agency-built landing pages renders into (see
 * web/templates/public/landing-page.html). Those pages are styled with Tailwind, so the shadow
 * root keeps our Bootstrap styles and their Tailwind styles from affecting each other.
 */
export const getLandingPageShadowRoot = (): ShadowRoot => {
    if (shadowRoot) {
        return shadowRoot;
    }
    let host = document.getElementById(SHADOW_HOST_ID);
    if (!host) {
        host = document.createElement('div');
        host.id = SHADOW_HOST_ID;
        document.body.appendChild(host);
    }
    shadowRoot = host.shadowRoot ?? host.attachShadow({ mode: 'open' });
    return shadowRoot;
};
